import { forwardRef, useEffect, useRef, useState } from 'react';
import { Input } from '@mui/joy';

// Keep the editable string separate from a parent which stores Number(value).
// A cleared field stays empty while focused, and comma works as decimal separator.
const NumericInput = forwardRef(function NumericInput({ value, onChange, onFocus, onBlur,
    inputMode = 'decimal', type, slotProps = {}, min, max, step, ...props }, ref) {
    const [draft, setDraft] = useState(String(value ?? ''));
    const focused = useRef(false);
    useEffect(() => { if (!focused.current) setDraft(String(value ?? '')); }, [value]);
    const integer = inputMode === 'numeric' || step === 1 || step === '1';
    const negative = Number(min) < 0;
    const valid = new RegExp(`^${negative ? '-?' : ''}\\d*${integer ? '' : '(?:[.,]\\d*)?'}$`);
    return <Input {...props} ref={ref} type="text" value={draft}
        slotProps={{ ...slotProps, input: { ...(typeof slotProps.input === 'object' ? slotProps.input : {}),
            inputMode: integer ? 'numeric' : 'decimal', autoComplete: 'off',
            'aria-valuemin': min, 'aria-valuemax': max } }}
        onFocus={e => { focused.current = true; if (e.target.value === '0') e.target.select(); onFocus?.(e); }}
        onChange={e => {
            const raw = e.target.value;
            if (!valid.test(raw)) return;
            setDraft(raw);
            const normalized = raw.replace(',', '.');
            onChange?.({ ...e, target: { ...e.target, value: normalized }, currentTarget: { ...e.currentTarget, value: normalized } });
        }}
        onBlur={e => { focused.current = false; setDraft(String(value ?? '')); onBlur?.(e); }} />;
});
export default NumericInput;
